import classnames from "classnames";
import * as React from 'react';

export const LoadingSpinner: React.FC<Props> = (props) => {

    return (
    <div className = {classnames("loading-spinner__container", {"is-enabled": props.withContainer, "no-padding": props.noPadding})}>
        <div className = {classnames("loading-spinner", {"is-inline": props.isInline})}>
            <span className = "loading-spinner__inner"></span>
        </div>
    </div>
    )

}

interface Props {
    withContainer?: boolean;
    isInline?: boolean;
    noPadding?: boolean;
}